module.exports = __webpack_public_path__ + "img/shortcode_hifi_1.1eb6b202.png";